import { createActions } from 'reduxsauce';

export interface BioState {
  data: IBioData[];
  isLoading: boolean;
  error: string;
}
export interface IBioData {
  id: number;
  title: string;
  desc: string;
  title2: string;
  desc2: string;
  title3: string;
}

export interface BioTypes {
  BIO: 'BIO';
  BIO_START: 'BIO_START';
  BIO_SUCCESS: 'BIO_SUCCESS';
  BIO_ERROR: 'BIO_ERROR';
  BIO_CLEAN_UP: 'BIO_CLEAN_UP';
}

const { Types, Creators } = createActions<BioTypes>({
  bio: ['data'],
  bioStart: null,
  bioSuccess: ['data'],
  bioError: ['error'],
  bioCleanUp: null,
});

export { Types };

export default Creators;
